import { render, staticRenderFns } from "./UserAttributePopover.vue?vue&type=template&id=832d2fac"
import script from "./UserAttributePopover.vue?vue&type=script&lang=js"
export * from "./UserAttributePopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports